<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['v-input v-input__slot', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <label v-if="schema.attributesRating.label" class="v-label-rating v-label" :for="generateId(schema.model)">
      {{ schema.attributesRating.label }}
      <span v-if="schema.rules.includes('required')" class="red--text">*</span>
    </label>

    <v-rating
      :rules="rules"
      :name="schema.model"
      :id="generateId(schema.model)"
      v-bind="schema.attributesRating"
      :readonly="schema.readonly"
      v-model="value"
      :ref="schema.model"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    ></v-rating>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  methods: {
    async onBlur() {
      this.changeEvents();
    },
  }
};
</script>

<style lang="scss" scoped>
.v-label-rating {
  margin-right: 8px;
}

.theme--light {
  .v-label-rating {
    color: rgba(0, 0, 0, 0.54);
  }
}

.theme--light {
  .v-label-rating {
    color: rgba(0, 0, 0, 0.54);
  }
}

.theme--dark {
  .v-label-rating {
    color: hsla(0, 0%, 100%, 0.7);
  }
}
</style>
